import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/switchMap';
import type { ActionsObservable, Epic } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import { FREE_ACCESS_LEVEL } from '@atlassian/jira-shared-types';
import {
	baseUrlSelector,
	projectIdSelector,
	projectTypeSelector,
	selectedAccessTypeSelector,
} from '../../selectors';
import { projectAccessTypesService } from '../../services';
import type { State } from '../../types';
import {
	type Action,
	fetchProjectAccessTypesSuccess,
	fetchProjectAccessTypesFail,
	setProjectAccessType,
} from './project-access-action-creators';
import { FETCH_PROJECT_ACCESS_TYPES } from './project-access-type';

const epic: Epic<Action, State> = (
	action$: ActionsObservable<Action>,
	store: MiddlewareAPI<State>,
) =>
	action$.ofType(FETCH_PROJECT_ACCESS_TYPES).switchMap(() => {
		const state = store.getState();
		const baseUrl = baseUrlSelector(state);
		const projectId = projectIdSelector(state);
		const projectType = projectTypeSelector(state);
		const currentAccessType = selectedAccessTypeSelector(state);

		return Observable.fromPromise(
			projectAccessTypesService.getProjectAccessTypes({
				baseUrl,
				projectType,
			}),
		)
			.flatMap((response) => {
				if (projectId || currentAccessType) {
					return Observable.of(fetchProjectAccessTypesSuccess(response));
				}
				const defaultAccessType = null;
				const setProjectAccessTypeAction = defaultAccessType
					? setProjectAccessType(defaultAccessType)
					: setProjectAccessType(
							response.accessTypes.find((x) => x.value === FREE_ACCESS_LEVEL) || defaultAccessType,
						);
				return Observable.of(
					fetchProjectAccessTypesSuccess(response),
					// @ts-expect-error - TS2769 - No overload matches this call.
					setProjectAccessTypeAction,
				);
			})
			.catch((e) => Observable.of(fetchProjectAccessTypesFail(e.message)));
	});

export default epic;
